import State from 'interfaces/state/State';
import { ITeam } from 'interfaces/state/TeamState';

export const isError$ = (state: State): boolean => state.team.isError;
export const isLoading$ = (state: State): boolean => state.team.isLoading;
export const teams$ = (state: State): ITeam[] => state.team.list;
